export class LayoutDto {
    _id;
    _organizationId;
    _environmentId;
    _creatorId;
    _parentId;
    name;
    identifier;
    description;
    channel;
    content;
    contentType;
    variables;
    isDefault;
    isDeleted;
    createdAt;
    updatedAt;
}
export var LayoutCreationSourceEnum;
(function (LayoutCreationSourceEnum) {
    LayoutCreationSourceEnum["DASHBOARD"] = "dashboard";
})(LayoutCreationSourceEnum || (LayoutCreationSourceEnum = {}));
export class LayoutIssuesDto {
    controls;
}
//# sourceMappingURL=layout.dto.js.map